import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { License, LicenseCreate, LicenseFilter } from '../data/license';

export function createLicenseService(client: AxiosInstance) {
  return createCrudService<License, LicenseCreate, LicenseFilter>(client, '/License', 'licenseId');
}

export type LicenseService = CrudService<License, LicenseCreate, LicenseFilter>;
